import { UserDataDto, UserManagementUsersDto } from '@core/services/dto';
import { OfferUserStatusEnum } from '@shared/enums/offer-user-status.enum';
import { formateUTCtoTZ } from '@shared/utils';

export class UserManagementModel {
  branch: string;
  email: string;
  firstName: string;
  id: string;
  lastLogin: string;
  lastName: string;
  status: string;
  name: string;
  phoneNumber: number;
  personNumber: number;
  roles: string[];
  branches: { id: number; name: string; isPrimary: boolean; isAllowed: boolean }[];
  type: 'Team' | 'Full';
  initials: string;
  fullName: string;
  isHidden?: boolean;
  createdById: string;
  created: string;
  createdBy: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    status: string;
    type: string;
    lastLogin: string | null;
    branch: { id: number; name: string } | null;
    roles: string[];
  } | null;
  lastModifiedById: string;
  lastModified: string;
  lastModifiedBy: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    status: string;
    type: string;
    lastLogin: string | null;
    branch: { id: number; name: string } | null;
    roles: string[];
  } | null;
  Active: any;
  maximumOverridePersonalAmount: number;
  maximumOverrideBusinessAmount: number;
  maximumRateOverridePersonalAmount: number;
  maximumRateOverrideBusinessAmount: number;

  constructor(dto: UserManagementUsersDto) {
    this.branch = dto.primaryBranchName;
    this.email = dto.email;
    this.firstName = dto.firstName;
    this.id = dto.id;
    this.lastLogin = dto.lastLogin ? formateUTCtoTZ(dto.lastLogin) : dto.lastLogin;
    this.lastName = dto.lastName;
    this.status = dto.status;
    this.phoneNumber = dto.phoneNumber;
    this.personNumber = dto.personNumber;
    this.name = `${dto.firstName} ${dto.lastName}`;
    this.branches = dto.branches.map(b => ({ id: b.id, name: b.name, isPrimary: b.isPrimary, isAllowed: b.isAllowed }));
    this.roles = dto.roles;
    this.type = dto.type;
    this.initials = `${dto.firstName.charAt(0)}${dto.lastName.charAt(0)}`;
    this.fullName = `${dto.firstName} ${dto.lastName}`;
    this.createdById = dto.createdById;
    this.created = dto.created;
    this.createdBy = dto.createdBy
      ? {
          id: dto.createdBy.id,
          firstName: dto.createdBy.firstName,
          lastName: dto.createdBy.lastName,
          email: dto.createdBy.email,
          status: dto.createdBy.status,
          type: dto.createdBy.type,
          lastLogin: dto.createdBy.lastLogin ? formateUTCtoTZ(dto.createdBy.lastLogin) : null,
          branch: dto.createdBy.branch ? { id: dto.createdBy.branch.id, name: dto.createdBy.branch.name } : null,
          roles: dto.createdBy.roles || [],
        }
      : null;
    this.maximumOverridePersonalAmount = dto.maximumOverridePersonalAmount;
    this.maximumOverrideBusinessAmount = dto.maximumOverrideBusinessAmount;
    this.maximumRateOverridePersonalAmount = dto.maximumRateOverridePersonalAmount;
    this.maximumRateOverrideBusinessAmount = dto.maximumRateOverrideBusinessAmount;
    this.lastModifiedById = dto.lastModifiedById;
    this.lastModified = dto.lastModified;
    this.lastModifiedBy = dto.lastModifiedBy
      ? {
          id: dto.lastModifiedBy.id,
          firstName: dto.lastModifiedBy.firstName,
          lastName: dto.lastModifiedBy.lastName,
          email: dto.lastModifiedBy.email,
          status: dto.lastModifiedBy.status,
          type: dto.lastModifiedBy.type,
          lastLogin: dto.lastModifiedBy.lastLogin ? formateUTCtoTZ(dto.lastModifiedBy.lastLogin) : null,
          branch: dto.lastModifiedBy.branch ? { id: dto.lastModifiedBy.branch.id, name: dto.lastModifiedBy.branch.name } : null,
          roles: dto.lastModifiedBy.roles || [],
        }
      : null;
  }

  isReadyForActivation(): boolean {
    return OfferUserStatusEnum[this.status] === OfferUserStatusEnum.InActive;
  }

  isReadyForReset(): boolean {
    return OfferUserStatusEnum[this.status] === OfferUserStatusEnum.Active;
  }
}



export class UserDataManagementModel {
  id: string;
  label: string;
  constructor(dto: UserDataDto) {
    this.id = dto.userId;
    this.label = dto.label;
  }
}
